import { Injectable } from '@angular/core';
import { Resource, ResourceParams, ResourceHandler, ResourceAction, ResourceRequestMethod, IResourceMethodPromise } from '@ngx-resource/core';
import { IMongooseResult } from './api.module';

@ResourceParams({
  pathPrefix: '/api/product'
})
@Injectable()
export class ProductResource extends Resource {

  constructor(handler: ResourceHandler) {
    super(handler);
  }


  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: ''
  })
  query: IResourceMethodPromise<any, IMongooseResult<any>>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/{!productkey}'
  })
  getOne: IResourceMethodPromise<any, any>;

}
